import { ClerkCompassPage } from '@pages/Auth/Clerk/pages/clerk-compass-page';
import { RouteObject } from 'react-router-dom';

export const clerkRoutes: RouteObject[] = [
  { path: '/login-compass', element: <ClerkCompassPage /> }
];
